import {Howl} from 'howler';
import audioSpriteSheet from '../../dist/audio.json';

const sound = new Howl(audioSpriteSheet);

export default sound;
